import axios from 'axios';
import { getSession } from '../utils/SessionUtils'; // adjust path if needed
import { apiCall } from '../utils/ApiUtils';

const BASE_URL = process.env.REACT_APP_ORDER_BASE_URL;


const companyCode= getSession("COMPANY")
// Fetch all orders for a company
export const findAllOrders = async (company=companyCode, params = {}) => {
  try {
    const response = await apiCall("GET", `${BASE_URL}/${companyCode}/findAllOrders`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

// Mark order as fulfilled
export const markOrderAsFulfilled = async (company=companyCode, orderID) => {
  try {
    await apiCall("POST", `${BASE_URL}/${companyCode}/markOrderAsFulfilled/${orderID}`);
  } catch (error) {
    throw error;
  }
};

// Mark order as delivered
export const markOrderAsDelivered = async (company=companyCode, orderID) => {
  try {
    await apiCall("POST", `${BASE_URL}/${companyCode}/markOrderAsDelivered/${orderID}`);
  } catch (error) {
    throw error;
  }
};


export const findAllOrderByFilter = async (company=companyCode, fromDate, toDate, orderStatus) => {
  try {
    const response = await apiCall("POST", `${BASE_URL}/${companyCode}/findAllOrderByFilter?fromDate=${fromDate}&toDate=${toDate}&orderStatus=${orderStatus}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTrackingInfo = async (company=companyCode, orderID, trackingNo, trackingWebsite) => {
  try {
    await apiCall("POST", `${BASE_URL}/${companyCode}/updateTrackingInfo/${orderID}?trackingNo=${trackingNo}&trackingWebsite=${trackingWebsite}`);
  } catch (error) {
    throw error;
  }
};